export const dateToYearMonthDayMinutes = (date, minutes) => {
  const newObject = {
    year: date.getYear() + 1900,
    day: date.getDate(),
    month: date.getMonth() + 1,
    minutes,
  };
  return newObject;
};

// capitalize the first letter of a string
export const setFirstLetterOfStringToCapital = (word) =>
  word ? word[0].toUpperCase() + word.slice(1).toLowerCase() : word;

export const getUserTimeZone = () => {
  const d = new Date();
  const tz = d.toLocaleString('en', { timeZoneName: 'short' }).split(' ').pop();
  return tz;
};

export const getTimeZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;

export const isShiftCompleted = (endTime) => endTime + 900000 < Date.now(); // 15 min after the end time
export const isShiftStarted = (shiftStart) => shiftStart - 900000 < Date.now(); // 15 min before the start time

// Convert a number to a dollar currency format (e.g., 1234 -> $1,234.00)
export const convertToDollars = (number, numOfDecimals) =>
  `$${number.toLocaleString('en-US', {
    minimumFractionDigits: numOfDecimals,
    maximumFractionDigits: numOfDecimals,
  })}`;

// Convert a number to a percentage format (e.g., 0.1234 -> 12.34%)

export const convertToPercentage = (number, numOfDecimals) =>
  `${(number * 100).toLocaleString('en-US', {
    minimumFractionDigits: numOfDecimals,
    maximumFractionDigits: numOfDecimals,
  })}%`;

export const fractionToPercent = (value) =>
  typeof value === 'number' ? Math.round(value * 100) : 0;

export const isValidNumber = (value) => typeof value === 'number' && !Number.isNaN(value);

export const capitalizeFirstLetter = (word) => word.charAt(0).toUpperCase() + word.slice(1);
